import Vue from 'vue'
import Router from 'vue-router'

import Login from './login/login'

import Home from './home/home'
import StoreInfo from './storeInfo/storeInfo'
import Menu from './menu/menu'
import BatchShelving from './batchShelving/batchShelving'
import Managers from './managers/managers'

import Orders from './orders/orders'
import Order from './order/order'

import List from './list/list'
import Item from './item/item'

import Coupon from './coupon/coupon'

import './style.css'

Vue.use(Router)
export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      window.lastPosition = savedPosition;
      return savedPosition
    } else {
      window.lastPosition = {
        x: 0,
        y: 0
      };
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes: [{
      path: '',
      redirect: '/home'
    },
    {
      name: 'home',
      path: '/home',
      component: Home,
    },
    {
      name: 'orders',
      path: '/orders',
      component: Orders,
    },
    {
      name: 'order',
      path: '/order',
      component: Order,
    },
    {
      name: 'storeInfo',
      path: '/storeInfo',
      component: StoreInfo,
    },
    {
      name: 'list',
      path: '/list',
      component: List,
    },
    {
      name: 'item',
      path: '/item',
      component: Item,
    },
    {
      name: 'menu',
      path: '/menu',
      component: Menu,
    },
    {
      name: 'batchShelving',
      path: '/batchShelving',
      component: BatchShelving,
    },
    {
      name: 'managers',
      path: '/managers',
      component: Managers,
    },
    {
      name: 'login',
      path: '/login',
      component: Login,
    },
    {
      name: 'coupon',
      path: '/coupon',
      component: Coupon,
    },
  ],
})